<template>
  <div
    id="scraped-articles-list"
    :class="{padding : viewType === 'Editor'}"
  >
    <p v-if="!hasArticles">
      No Content Items Available
    </p>
    <content-item-card
      v-else
      v-for="(article, index) in GET_SUCCESSFULLY_SCRAPED_CONTENT_ITEMS"
      class="bg-secondary"
      :id="`article-${article.encodedExternalId}`"
      :key="index"
      :index="index"
      :article="article"
      :data-test="`content-list-item-${index}`"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import * as contentTypes from '@/modules/content/store/types';
import ContentItemCard from '@/modules/content/components/Articles/ContentItemCard.vue';

export default {
  name: 'SuccessfullyScrapedContentItems',
  components: {
    ContentItemCard,
  },
  methods: {
    ...mapActions('content', [
      contentTypes.SET_SELECTED_ARTICLE_UUID,
    ]),
    handleKeydown(e) {
      if (this.GET_CREATIVES_CARROUSEL_COVERED) {
        return;
      }
      const keyCode = e.key;
      if (keyCode === 'w' || keyCode === 's') {
        const contentItems = this.GET_SUCCESSFULLY_SCRAPED_CONTENT_ITEMS;
        const selectedArticle = contentItems.find((article) => article.encodedExternalId === this.selectedArticleUuid);
        const currentIndex = selectedArticle ? contentItems.indexOf(selectedArticle) : -1;

        let indexToUpdate = currentIndex;
        if (keyCode === 'w' && currentIndex > 0) {
          indexToUpdate -= 1;
        }
        if (keyCode === 's' && currentIndex > -1 && currentIndex < contentItems.length - 1) {
          indexToUpdate += 1;
        }
        if (indexToUpdate !== currentIndex) {
          this.SET_SELECTED_ARTICLE_UUID(contentItems[indexToUpdate].encodedExternalId);
        }
      }
    },
  },
  computed: {
    ...mapGetters('content', [
      contentTypes.GET_IN_PROGRESS_CONTENT_ITEMS,
      contentTypes.GET_SUCCESSFULLY_SCRAPED_CONTENT_ITEMS,
      contentTypes.GET_CREATIVES_CARROUSEL_COVERED,
    ]),
    ...mapState('campaigns', [
      'viewType',
    ]),
    ...mapState('content', [
      'selectedArticleUuid',
    ]),
    hasArticles() {
      return this.GET_IN_PROGRESS_CONTENT_ITEMS?.length || this.GET_SUCCESSFULLY_SCRAPED_CONTENT_ITEMS?.length;
    },
  },
  mounted() {
    if (!process.server) {
      window.addEventListener('keydown', this.handleKeydown);
    }
  },
  beforeDestroy() {
    if (!process.server) {
      window.removeEventListener('keydown', this.handleKeydown);
    }
  },
};
</script>
<style lang="scss" scoped>
.padding {
  padding-bottom: 75px;
}
</style>
